import { FC } from 'react';

import { SvgIcon, SvgIconProps, useTheme } from '@thirdspacelearning/library';

interface Props extends SvgIconProps {}

const BadgeAvailable: FC<Props> = ({ ...props }) => {
    const theme = useTheme();

    return (
        <SvgIcon
            width="81"
            height="81"
            viewBox="0 0 81 81"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid="badge-available"
            {...props}
        >
            <rect
                x="3.11538"
                y="3.11538"
                width="74.7692"
                height="74.7692"
                rx="37.3846"
                fill="white"
            />
            <rect
                x="3.11538"
                y="3.11538"
                width="74.7692"
                height="74.7692"
                rx="37.3846"
                stroke={theme.palette.primary.main}
                strokeWidth="6.23077"
                fill="white"
            />
            <path
                d="M41.5383 31.9123L40.3337 31.8065C40.0326 31.7821 32.9309 31.135 30.1351 28.3432C26.5008 24.7089 29.2479 21.966 30.4199 20.7939C31.592 19.6218 34.335 16.8788 37.9692 20.509C40.761 23.3008 41.4081 30.4065 41.4325 30.7077L41.5383 31.9123ZM34.3513 20.7288C33.5536 20.7288 32.8007 21.2863 31.8606 22.2305C30.1473 23.9438 29.6996 25.0264 31.5757 26.9025C33.1263 28.453 36.9315 29.2914 39.2593 29.6292C38.9215 27.3054 38.0832 23.5002 36.5326 21.9456C35.6861 21.0991 35.0024 20.7247 34.3513 20.7247V20.7288Z"
                fill="#C00030"
            />
            <path
                d="M40.02 31.9118L40.1258 30.7072C40.1502 30.406 40.7973 23.3044 43.5891 20.5085C47.2234 16.8743 49.9663 19.6213 51.1384 20.7934C52.3105 21.9655 55.0535 24.7085 51.4233 28.3427C48.6315 31.1345 41.5258 31.7816 41.2246 31.806L40.02 31.9118ZM45.0298 21.9492C43.4793 23.4998 42.6409 27.309 42.3031 29.6328C44.6269 29.295 48.4321 28.4566 49.9867 26.9061C51.8628 25.0259 51.4152 23.9474 49.7018 22.2341C47.9885 20.5207 46.9059 20.0731 45.0298 21.9492Z"
                fill="#C00030"
            />
            <path
                d="M40.7995 32.0581C42.3323 32.0581 43.575 30.8154 43.575 29.2825C43.575 27.7497 42.3323 26.507 40.7995 26.507C39.2666 26.507 38.0239 27.7497 38.0239 29.2825C38.0239 30.8154 39.2666 32.0581 40.7995 32.0581Z"
                fill="#C00030"
            />
            <path
                d="M60.2244 34.0264H21.0112V56.1094C21.0112 57.0773 21.7958 57.8618 22.7636 57.8618H58.472C59.4398 57.8618 60.2244 57.0773 60.2244 56.1094V34.0264Z"
                fill="#DF8603"
            />
            <path
                d="M60.6517 29.283H20.3479C19.864 29.283 19.4717 29.6752 19.4717 30.1592V34.6822C19.4717 35.1661 19.864 35.5584 20.3479 35.5584H60.6517C61.1356 35.5584 61.5279 35.1661 61.5279 34.6822V30.1592C61.5279 29.6752 61.1356 29.283 60.6517 29.283Z"
                fill="#FFA726"
            />
            <rect
                x="37.8721"
                y="29.4816"
                width="5.54908"
                height="28.3295"
                fill="#C00030"
            />
        </SvgIcon>
    );
};

export default BadgeAvailable;
